export const clientStyle = theme => {
  const layoutPadding = theme.variables?.layoutPadding;
  const wrapperPadding = layoutPadding
    ? `${layoutPadding.vertical}px ${layoutPadding.horizontal}px`
    : 0;
  

  const contentPadding = theme.variables?.contentPadding;

  return {
    wrapper: {
      position: 'relative',
      top: '0',
      height: '100%',
      width: '100%',
      display: 'flex',
      padding: wrapperPadding,
      boxSizing: 'border-box',
    },

  headerHeight: {
    ...theme.mixins.headerHeight,
  },

  content: {
    flexGrow: 1,
    paddingTop: contentPadding?.top ?? theme.spacing(3),
    paddingBottom: contentPadding?.bottom ?? theme.spacing(3),
    paddingLeft: contentPadding?.left ?? theme.spacing(3),
    paddingRight: contentPadding?.right ?? theme.spacing(3),
    maxHeight: '100%',
    width: '100%',
    overflowScrolling: 'touch',
    overflow: 'auto',
    position: 'relative',

    [theme.breakpoints.down('md')]: {
      paddingLeft: contentPadding?.left ?? theme.spacing(2),
      paddingRight: contentPadding?.right ?? theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: contentPadding?.left ?? theme.spacing(1),
      paddingRight: contentPadding?.right ?? theme.spacing(1),
    },
  },
    showCart: {
      [theme.breakpoints.down('xs')]: {
        paddingBottom: theme.spacing(3) + theme.spacing(2) * 2 + 30,
      },
    },
  }
}
